var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"mr-2"},[_c('tl-icon',{staticClass:"fa-2x text-white",attrs:{"icon":"spinner","spin":""}})],1),_vm._v(" "),_c('h2',{staticClass:"mb-0 h2 text-white"},[_vm._v("\n    "+_vm._s(_vm.$t("common.warnings.loading-available-products"))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }